module.exports = __webpack_public_path__ + "static/media/productAddedTick.173f1bd1.svg";